export const profilesToAppearanceTrackingIds = (
  profiles: MinimalProfileDepiction[],
): string | undefined =>
  profiles
    .map(({ appointmentSummary, id }) => `${id}:${appointmentSummary?.count ?? 0}`)
    .join(',') || undefined;

interface MinimalProfileDepiction {
  id: string;
  appointmentSummary?: null | { count: number };
}
